export default class WeitergabeStatus {

  static get ABGELEHNT() {
    return 'ABGELEHNT'
  }

  static get ANGENOMMEN() {
    return 'ANGENOMMEN'
  }
}
